import { memo } from 'react';
import { Handle, Position, type NodeProps } from '@xyflow/react';
import { CircleStop } from 'lucide-react';
import { useUIStore } from '@/stores/ui-store';
import type { EndNodeData } from '@/types/field-mapping-flow';

function EndNodeComponent({ data }: NodeProps) {
  const _nodeData = data as unknown as EndNodeData;
  const isDark = useUIStore((s) => s.theme) === 'dark';

  return (
    <div
      className="flex items-center gap-2 rounded-full px-4 py-2 shadow-md"
      style={{
        background: isDark
          ? 'linear-gradient(135deg, #4c0519 0%, #881337 100%)'
          : 'linear-gradient(135deg, #fff1f2 0%, #ffe4e6 100%)',
        border: isDark ? '1px solid #9f1239' : '1px solid #fecdd3',
      }}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="!h-2.5 !w-2.5 !border-2"
        style={{ borderColor: '#f43f5e', background: isDark ? '#4c0519' : 'white' }}
      />

      <div className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full" style={{ background: '#e11d48' }}>
        <CircleStop className="h-3 w-3 text-white" />
      </div>
      <span className="text-xs font-bold" style={{ color: isDark ? '#fb7185' : '#e11d48' }}>End</span>
    </div>
  );
}

export const EndNode = memo(EndNodeComponent);
